import { c as _c } from "react/compiler-runtime";
import { cx } from "@/utils/cx";
export function SortDirectionGlyph(t0) {
  const $ = _c(11);
  const {
    direction
  } = t0;
  const upActive = direction === "asc";
  const downActive = direction === "desc";
  const t1 = upActive ? "fill-fg-primary" : "fill-fg-quaternary";
  let t2;
  if ($[0] !== t1) {
    t2 = cx(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <path d="M5 1.2 8.6 5.4H1.4L5 1.2Z" className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = downActive ? "fill-fg-primary" : "fill-fg-quaternary";
  let t5;
  if ($[4] !== t4) {
    t5 = cx(t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <path d="M5 12.8 1.4 8.6h7.2L5 12.8Z" className={t5} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <svg aria-hidden="true" viewBox="0 0 10 14" className="size-3.5 shrink-0">{t3}{t6}</svg>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}